import { CART_ACTIONS } from './cart.types'

export const deleteCartItemAction = cartItemId => ({
  type: CART_ACTIONS.DELETE_CART_ITEM,
  payload: cartItemId
})

export const clearCartAction = () => ({
  type: CART_ACTIONS.CLEAR_CART
})
